export default __webpack_public_path__ + "static/media/category_page_descriptions.c8a27172.svg";